<template>
  <div class="level" v-if="app!=null && app.data !=null">
    <div class="launcher" id="level-content">
      <div id="level-selector">
        <div @click="app.displaySettings()" id="boule" class="new-boule"><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"  style="fill: rgb(255, 255, 255);"><path d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"/></svg></div>
        <h1>Peintures</h1>
        <h2>Choisissez<br>votre niveau</h2>
        <div>
          <button style="margin-bottom:10px;" @click="app.juniorLevel">Junior</button>
          <button style="margin-bottom:10px;" @click="app.decouverteLevel">Découverte</button>
          <button style="margin-bottom:10px;" @click="app.expertLevel">Expert</button>
        </div>
        <img id="line" src="line.png">
      </div>  
      <div id="footer">
        <p>Ouvrez l'oeil, un bonus<br>est à découvrir en fin de parcours !</p>
        <blockquote>Bonne visite !</blockquote>
      </div>
      
      
    </div>

    <quizz
      v-bind:app="app"
    ></quizz>


    <settings
      v-bind:app="app"
    ></settings>

    
  </div>
</template>

<script>

import quizz from './quizz.vue';
import settings from './settings.vue';

export default {
  name: 'LevelVue',
  props: {
    app:Object
  },
  components :{
    quizz,
    settings
  }
}
</script>


